import {
  ActionIcon,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconEdit, IconPlus, IconSearch, IconTrash } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import CreateProductCategoryView from "./CreateView";
import DeleteProductCategory from "./DeleteView";
import EditProductCategoryView from "./EditView";
import ProductSelection from "./ModalProductSelected/ProductSelect";
import ProductSelecteds from "./ProductSelected";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  paymentMethod?: string;
  invoiceType?: string;
}

const FaceBookAds = () => {
  // Khởi tạo component InventoryReportList
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  type Search = string | number | boolean | object | null;
  const [searchs, setSearchs] = useState<Search>(null);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<CategoryItem[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [editViewProduct, setEditViewProduct] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    },
  });

  type CategoryItem = {
    id: number;
    title: string;
    description: string;
    googleCategoryId: string;
    productCount: number;
    searchFulltext: string;
    createTime: string;
    createBy: string;
    lastUpdate: string;
    lastUpdateBy: string;
  };

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };
  const styleTableMantine = {
    fontWeight: "bold",
  };
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "title",
        header: "Danh sách",
        size: 200,
        minSize: 200,
      },
      {
        accessorKey: "productCount",
        header: "Số lượng",
        size: 135,
      },
      {
        accessorKey: "createTime",
        header: "Thời gian tạo",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "link",
        header: "FaceBook Feed",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <Group>
            <Text>{`/api/facebook-ads?id=${row.original.id}`}</Text>
            <a
              href={`${hacomUrl}/api/facebook-ads?id=${row.original.id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c7ed6", textDecoration: "underline" }}
            >
              FaceBook Feed
            </a>
          </Group>
        ),
      },
      {
        accessorKey: "GoogleFeed",
        header: "Google Feed",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <Group>
            <Text>{`/api/google-ads?id=${row.original.id}`}</Text>
            <a
              href={`${hacomUrl}/api/google-ads?id=${row.original.id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c7ed6", textDecoration: "underline" }}
            >
              Google Feed
            </a>
          </Group>
        ),
      },

      {
        accessorKey: "description",
        header: "Mô tả",
      },
      {
        accessorKey: "action1",
        header: "Thao tác sản phẩm",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Sửa sản phẩm">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={() =>
                  modals.open({
                    size: "xl",
                    title: <Title order={5}>Danh sách sản phẩm đã chọn</Title>,
                    children: (
                      <ProductSelecteds
                        idItems={row.original.id}
                        onClose={() => {
                          modals.closeAll();
                        }}
                        fetchDataList={fetchData}
                      />
                    ),
                  })
                }
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Thêm sản phẩm">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() =>
                  modals.open({
                    size: "xl",
                    title: <Title order={5}>Danh sách sản phẩm đã chọn</Title>,
                    children: (
                      <ProductSelection
                        idItems={row.original.id}
                        onClose={() => {
                          modals.closeAll();
                        }}
                        fetchDataList={fetchData}
                      />
                    ),
                  })
                }
              >
                <IconPlus size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác danh mục",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={() => EditItem(row.original)}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteData([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }

      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${
        API_ROUTE.GET_LIST_FACEBOOK_ADS
      }?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data.lists;
        setData(result);
        setRowCount(response.data.count);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(form.getValues())
      );
    }
  };
  const deleteData = async (ids: number[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Xóa dữ liệu này!</Title>
            </>
          ),
          size: "550px",
          children: (
            <DeleteProductCategory
              idItems={ids}
              onClose={setDeleteViewStatus}
            />
          ),
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const CreateItem = async () => {
    modals.open({
      size: "lg",
      title: <Title order={5}>Thêm mới danh mục</Title>,
      children: (
        <CreateProductCategoryView
          onClose={() => setDeleteViewStatus((prev) => !prev)}
        />
      ),
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  };

  const EditItem = async (item: CategoryItem) => {
    modals.open({
      size: "lg",
      title: <Title order={5}>Chỉnh sửa danh mục</Title>,
      children: (
        <EditProductCategoryView
          item={item}
          onClose={() => setEditViewProduct((prev) => !prev)}
        />
      ),
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  };
  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["action1", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.invoiceId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus, editViewProduct]);
  return (
    <Box>
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>

          <Group>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                CreateItem();
              }}
            >
              Thêm mới
            </Button>
            <Button
              mt={10}
              mr={10}
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const selectedIds = Object.keys(rowSelection).map(
                  (key) => data[Number(key)].id
                );
                if (selectedIds && selectedIds.length < 1) {
                  NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                  return null;
                }
                await deleteData(selectedIds);
              }}
            >
              Xóa (Đã chọn)
            </Button>
          </Group>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default FaceBookAds;
